import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgToastModal',
})
export default class CmgToastModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.toast.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.toast.args;
  }

  get title(): string | null {
    return (this.args && this.args.title) || '';
  }

  get subTitle(): string | null {
    return (this.args && this.args.subTitle) || '';
  }

  get body(): string | null {
    return (this.args && this.args.body) || '';
  }

  get legalCopy(): string {
    return (this.args && this.args.legalCopy) || '';
  }

  get icon(): string | null {
    return (this.args && this.args.icon) || null;
  }

  get bodyOnly(): boolean | null {
    return (this.args && this.args.bodyOnly) || null;
  }

  get isUpdatedVersion(): boolean {
    return (this.args && this.args.isUpdatedVersion) || false;
  }

  get manualWidth(): string {
    return this.isUpdatedVersion ? '370px' : '250px';
  }

  get visbileTimeLength(): number {
    return (this.args && this.args.visibleTimeLength) || 5000;
  }

  get unmaskContent(): boolean {
    return (this.args && this.args.unmaskContent) || false;
  }

  after() {
    if (this.args && this.args.after) {
      this.args.after();
    }
  }

  @Watch('visible', { immediate: false })
  onVisibleChanged(newVisible: boolean) {
    if (newVisible === true) {
      setTimeout(() => {
        if (this.visible) {
          this.after(); // call after() before it gets removed from the store args
          this.$services.ui.setModalVisibility('toast', false);
        }
      }, this.visbileTimeLength);
    }
  }

  onCancel() {
    this.after(); // call after() before it gets removed from the store args
    this.$services.ui.setModalVisibility('toast', false);
  }
}
